import { Component, inject } from '@angular/core';
import { IconsService } from '../../../services/icons.service';
import { IconsAsignaturasService } from '../../../services/icons-asignaturas.service';
import { CargarConfService } from '../../../services/cargar-conf.service';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { aplicacionItem, filterData } from '../../../interface/data-core';
import { agruparAplicacionesPorGradoYAsignatura, onAddClass, onRemoveClass } from '../../../utils/generales';

@Component({
    selector: 'app-buscador-general',
    imports: [FormsModule, CommonModule],
    templateUrl: './buscador-general.component.html',
    styleUrl: './buscador-general.component.css'
})
export class BuscadorGeneralComponent {

    public _icon = inject(IconsService);
    public _icon_asignatura = inject(IconsAsignaturasService);
    public _conf = inject(CargarConfService);

    public searchTerm: string = '';
    public searchResults: any[] = [];
    public listCoincidencias: aplicacionItem[] = [];


    /**
     * Busca cuando el usuario escribe (con debounce automático del navegador)
     */
    onSearch(): void {

        if (!(this.searchTerm.trim().length > 0)) {
            this.clearSearch();
            return;
        }

        if (this.searchTerm.trim().length <= 3) {
            this.searchResults = [];
            onRemoveClass('d_overlaycontegrl_searchhome', 'onShow');
            return;
        }

        if (this.searchTerm.trim().length >= 3) {
            onAddClass('d_overlaycontegrl_searchhome', 'onShow');
        }

        const data = this._conf.dataGlobal?.aplicaciones || [];
        const term = this.searchTerm.toLowerCase();

        this.searchResults = data
            .filter(app =>
                app.n?.toLowerCase().includes(term) ||
                app.o?.toLowerCase().includes(term) ||
                app.pc?.toLowerCase().includes(term)
            )
        //.slice(0, 10);

        this.listCoincidencias = agruparAplicacionesPorGradoYAsignatura(this.searchResults, this._conf.dataGlobal?.grados || [], this._conf.dataGlobal?.asignaturas || []) || [];
        console.debug(`Resultados de búsqueda para "${this.searchTerm}":`, this.listCoincidencias);

        if (this.listCoincidencias.length > 0) {
            this.listCoincidencias.forEach(item => {
                item.action = () => {
                    let filter : filterData = {
                        grado: item.g,
                        class_asignatura: item.asignatura?.class || null,
                        asignatura: item.a,
                        aplicacion: item.listId,
                        tema: null,
                        texto: this.searchTerm,
                        categoria: []
                    };
                    console.debug(`Filtro aplicado:`, filter);
                    this._conf.updateFilters(filter);
                };
            });

            //this.onToggleSearch();
        }
    }

    /**
     * Limpia la búsqueda
     */
    clearSearch(): void {
        onRemoveClass('d_overlaycontegrl_searchhome', 'onShow');
        this.searchTerm = '';
        this.searchResults = [];
        this.listCoincidencias = [];


    }



    /**
     * Toggle del overlay
     */
    onToggleSearch(): void {
        const overlay = document.getElementById('d_overlaycontegrl_searchhome');
        overlay?.classList.toggle('onShow');
    }
}
